function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useEffect, useState } from 'react';
import feathers from '@cryptosheets/feathers-client';
import { ArrowRightOutlined, FileExcelOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { downloadExcelFromWeb } from '@cryptosheets/util';
var client = feathers('localStorage', 'socket');

function DownloadTemplate(_ref) {
  var {
    templateid
  } = _ref;
  var [fileName, setFileName] = useState('download');
  var [record, setRecord] = useState(null);
  var [excel, setExcel] = useState(null);
  var [google, setGoogle] = useState(null);
  useEffect(() => {
    function getTemplate(_x) {
      return _getTemplate.apply(this, arguments);
    }

    function _getTemplate() {
      _getTemplate = _asyncToGenerator(function* (templateId) {
        var template = yield client.service('templates').get(templateId);
        var {
          name,
          template: content,
          googleUrl
        } = template;
        setFileName(name);
        setRecord(template);
        setExcel(content);
        setGoogle(googleUrl);
      });
      return _getTemplate.apply(this, arguments);
    }

    getTemplate(templateid);
  }, [templateid]);
  return /*#__PURE__*/React.createElement(Space, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(FileExcelOutlined, null),
    type: "primary",
    onClick: () => downloadExcelFromWeb(excel, fileName)
  }, "Download Excel"), google && /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    href: google,
    target: "_blank"
  }, "Open in Google Sheets ", /*#__PURE__*/React.createElement(ArrowRightOutlined, null)));
}

export default DownloadTemplate;